import type { Candle } from '../../types/api';

const lastBars = new Map<string, Candle>();

export function getLastBar(symbol: string, interval: string): Candle | undefined {
  return lastBars.get(cacheKey(symbol, interval));
}

export function setLastBar(symbol: string, interval: string, bar: Candle): void {
  lastBars.set(cacheKey(symbol, interval), bar);
}

function cacheKey(symbol: string, interval: string): string {
  return `${symbol}:${interval}`;
}
